// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d0b41403","156":"fbe8f69c","185":"30d5841a","200":"a8e07ac9","241":"4286334f","565":"3a0d46b3","616":"9700624a","654":"293b3567","768":"f1dce226","806":"3879ad19","939":"c2c1c4b7"}[chunkId] + ".chunk.js";
};